// @ts-nocheck
/* eslint-disable */

import * as Types from '../../../graphql/v4/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HeaderBasketQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HeaderBasketQuery = { __typename?: 'Query', basket: { __typename?: 'Basket', productsCount: number } };


export const HeaderBasketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HeaderBasket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productsCount"}}]}}]}}]} as unknown as DocumentNode;
export function useHeaderBasketQuery(baseOptions?: Apollo.QueryHookOptions<HeaderBasketQuery, HeaderBasketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderBasketQuery, HeaderBasketQueryVariables>(HeaderBasketDocument, options);
      }
export function useHeaderBasketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderBasketQuery, HeaderBasketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderBasketQuery, HeaderBasketQueryVariables>(HeaderBasketDocument, options);
        }
export function useHeaderBasketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HeaderBasketQuery, HeaderBasketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeaderBasketQuery, HeaderBasketQueryVariables>(HeaderBasketDocument, options);
        }
export type HeaderBasketQueryHookResult = ReturnType<typeof useHeaderBasketQuery>;
export type HeaderBasketLazyQueryHookResult = ReturnType<typeof useHeaderBasketLazyQuery>;
export type HeaderBasketSuspenseQueryHookResult = ReturnType<typeof useHeaderBasketSuspenseQuery>;